/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
function isActivationKey(key) {
  return key === "Enter" || key === " ";
}
const numberKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
export {
  isActivationKey as i,
  numberKeys as n
};
